import { render, staticRenderFns } from "./DTU_PLC.vue?vue&type=template&id=068f39a4&"
import script from "./DTU_PLC.vue?vue&type=script&lang=js&"
export * from "./DTU_PLC.vue?vue&type=script&lang=js&"
import style0 from "./DTU_PLC.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports